const convertDateTimeToMMSlashDDSlashYYYY = (date: Date) => {
  const day = date.toLocaleString("default", { day: "2-digit" });
  const month = date.toLocaleString("default", { month: "2-digit" });
  const year = date.toLocaleString("default", { year: "numeric" });
  return `${month}/${day}/${year}`;
};
const formatTime = (time: string) => {
  const hrNumber = Number(time.substring(0, 2));
  const hour =
    hrNumber <= 12
      ? time.substring(0, 2)
      : String(hrNumber - 12).padStart(2, "0");
  const ampm = hrNumber <= 12 ? " AM" : " PM";
  const newTime = hour + time.substring(2);
  return newTime + ampm;
};

// Format date as YYYY-MM-DD
const formatDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const formatDateToMDYYYY = (date: Date): string => {
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    return "";
  }
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

export {
  convertDateTimeToMMSlashDDSlashYYYY,
  formatTime,
  formatDate,
  formatDateToMDYYYY,
};
export const formatDateForCallSchedule = (dateString: string) => {
  if (!dateString) return "";

  let date: Date;
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    return dateString;
  }
  if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
    const [month, day, year] = dateString.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }
  date = new Date(dateString);
  if (!isNaN(date.getTime())) {
    return date.toISOString().split("T")[0];
  }

  return "";
};
